/**
 * @generated SignedSource<<fafa171b7a756da54e3ae07cf918c0dd>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "model",
                    "variableName": "model"
                }
            ],
            "concreteType": "UpdateEventPayload",
            "kind": "LinkedField",
            "name": "updateEvent",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EdgeOfEvent",
                    "kind": "LinkedField",
                    "name": "eventEdge",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAdditionAvailableInTimeReport",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "EditIsAdditionAvailableInTimeReportMutation",
            "selections": (v1 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "EditIsAdditionAvailableInTimeReportMutation",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "f113f31905f13ab45e85197a6f696a7a",
            "id": null,
            "metadata": {},
            "name": "EditIsAdditionAvailableInTimeReportMutation",
            "operationKind": "mutation",
            "text": "mutation EditIsAdditionAvailableInTimeReportMutation(\n  $model: UpdateEventRequestInput!\n) {\n  updateEvent(model: $model) {\n    eventEdge {\n      node {\n        id\n        isAdditionAvailableInTimeReport\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "d3f510dae257c3eb9b4167cae491198e";
export default node;
